export default "__VITE_ASSET__BfVU6pJc__"